import { render, staticRenderFns } from "./Teachingvideo.vue?vue&type=template&id=1b5b8a26"
import script from "./Teachingvideo.vue?vue&type=script&lang=js"
export * from "./Teachingvideo.vue?vue&type=script&lang=js"
import style0 from "./Teachingvideo.vue?vue&type=style&index=0&id=1b5b8a26&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports